var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9064 0.5H8.02749C7.96773 0.5 7.91148 0.529297 7.87632 0.577344L4.54702 5.16641L1.21773 0.577344C1.18257 0.529297 1.12632 0.5 1.06655 0.5H0.187648C0.111477 0.5 0.0669453 0.586719 0.111477 0.648828L4.24351 6.34531C4.39351 6.55156 4.70054 6.55156 4.84937 6.34531L8.9814 0.648828C9.0271 0.586719 8.98257 0.5 8.9064 0.5Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret_down.88102e260cff183c1af7e5bd099f7c5b.svg";
export { ForwardRef as ReactComponent };